import styled from "@emotion/styled";
import { Button, Typography } from "@mui/material";

export const DetailsHeadings = styled(Typography)(({ theme }) => ({
  fontSize: theme.size[13],
  // lineHeight: theme.size[41],
  fontWeight: theme.fontWeight[500],
  color: theme.palette.cards.heading,
  marginBottom: "8px",
}));
export const AlertMessage = styled(Typography)(({ theme }) => ({
  fontSize: theme.size[11],
  lineHeight: theme.size[30],
  fontWeight: theme.fontWeight[400],
  color: theme.palette.cards.heading,
}));
export const SearchHeading = styled(Typography)(({ theme }) => ({
  fontSize: theme.size[15],
  lineHeight: theme.size[14],
  fontWeight: theme.fontWeight[600],
  color: theme.palette.cards.heading,
}));

export const SearchLink = styled(Button)(({ theme }) => ({
  fontWeight: theme.fontWeight[500],
  fontSize: theme.size[13],
  color: theme.palette.table.heading,
  textTransform: "none",
  textDecoration: "underline",
  "&:hover": {
    textDecoration: "underline",
    background: "transparent",
  },
}));

export const DetailsLink = styled(Button)(({ theme }) => ({
  fontWeight: theme.fontWeight[400],
  fontSize: theme.size[12],
  lineHeight: theme.size[14],
  color: theme.palette.primary.main,
  textTransform: "none",
  textDecoration: "underline",
  justifyContent: "left",
  "&:hover": {
    textDecoration: "underline",
    background: "transparent",
    color: `${theme.palette.cards.icon}`,
  },
}));
